import { DomainSerializer } from 'src/app/global/serializables/domain.serializer';
import { ConciliacaoBancariaDoc } from '../domain/conciliacao-bancaria-doc.model';

export class ConciliacaoBancariaDocSerializer extends DomainSerializer<ConciliacaoBancariaDoc> {}
